var map = {
	"./390813778181.png": 443,
	"./3912345678.png": 901,
	"./393201234567.png": 245,
	"./393335678901.png": 87,
	"./393338765432.png": 571,
	"./393339876543.png": 441,
	"./393387890123.png": 986,
	"./393402345678.png": 580,
	"./393456543210.png": 976,
	"./393473456789.png": 490,
	"./393484567890.png": 751,
	"./393496789012.png": 641,
	"./393661234567.png": 375,
	"./Bianchi.png": 495,
	"./Enrico.png": 519,
	"./bg_music.mp3": 633,
	"./chain.mp3": 659,
	"./end.mp3": 823,
	"./homme.png": 656,
	"./keypress.mp3": 6,
	"./keypress.wav": 274,
	"./suspense.wav": 461
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;